import { render, staticRenderFns } from "./PlayerInfo.vue?vue&type=template&id=f3020222"
import script from "./PlayerInfo.vue?vue&type=script&lang=js"
export * from "./PlayerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports